import React from "react";

const DailyDigestIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="55.106"
      height="40.815"
      viewBox="0 0 55.106 40.815"
    >
      <g id="db29" transform="translate(0 0)">
        <path
          id="Path_1250"
          data-name="Path 1250"
          d="M55.119,59.834H8.465V94.528h0s0,.007,0,.013a2.077,2.077,0,0,1-2.114,2.038,2.075,2.075,0,0,1-2.112-2.038v-.013h0V63.917H.013V94.541h0a6.234,6.234,0,0,0,6.338,6.108H48.782a6.233,6.233,0,0,0,6.337-6.108h0V59.834ZM50.894,94.528h0v.013a2.074,2.074,0,0,1-2.112,2.038H12.323a5.852,5.852,0,0,0,.363-2.038h0V63.917H50.9Z"
          transform="translate(-0.013 -59.834)"
          fill={fill ? fill : "#fb9f34"}
        />
        <rect
          id="Rectangle_3509"
          data-name="Rectangle 3509"
          width="12.673"
          height="12.243"
          transform="translate(17.039 18.465)"
          fill={fill ? fill : "#fb9f34"}
        />
        <rect
          id="Rectangle_3510"
          data-name="Rectangle 3510"
          width="29.571"
          height="4.08"
          transform="translate(17.039 10.302)"
          fill={fill ? fill : "#fb9f34"}
        />
        <rect
          id="Rectangle_3511"
          data-name="Rectangle 3511"
          width="12.673"
          height="4.08"
          transform="translate(33.937 18.465)"
          fill={fill ? fill : "#fb9f34"}
        />
        <rect
          id="Rectangle_3512"
          data-name="Rectangle 3512"
          width="12.673"
          height="4.08"
          transform="translate(33.937 26.628)"
          fill={fill ? fill : "#fb9f34"}
        />
      </g>
    </svg>
  );
};

export default DailyDigestIcon;
